import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import "./Editor.css";

interface Props {
    resetBody: boolean;
    body: string;
    setBody: Dispatch<SetStateAction<string>>;
    setResetBody: Dispatch<SetStateAction<boolean>>;
}

export function Editor({ body, setBody, resetBody, setResetBody }: Props) {
    const editorRef = useRef<HTMLDivElement | null>(null);
    const quillInstance = useRef<Quill | null>(null);

    useEffect(() => {
        if (editorRef.current) {
            quillInstance.current = new Quill(editorRef.current, {
                theme: 'snow',
                placeholder: 'Escribir...',
                modules: {
                toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link', 'image', 'video'],
                    ['clean'], 
                ],
                },
            });

            quillInstance.current.on("text-change", () => {
                if (quillInstance.current) {
                    //const content = quillInstance.current.root.innerHTML;
                    const content = quillInstance.current.root.innerText;
                    setBody(content);
                }
            });
        }

        return () => { quillInstance.current = null };
    }, []);

    useEffect(() => {
        if(resetBody) {
            quillInstance.current?.setContents([]);
            setBody("");
            setResetBody(false);
        }
    }, [resetBody]);

    return (
        <div>
            <div className="border-0" ref={editorRef} style={{ height: '250px', border: 0 }} />
        </div>
    );
};